import {get} from 'components/api';
import {requirement} from 'constants/url';

function getRequirement(additional: string, token: string) {
  const url = `${requirement}?additional=${additional}`;
  return get(url, token);
}

export function getRequirementWithoutAdditional(
  filters: string,
  token: string,
) {
  let options = new URLSearchParams();
  options.append('filter', JSON.stringify(filters));
  const url = `api/Profile/ProfileWithoutDeleting?${options && options}`;
  return get(url, token);
}

export default getRequirement;
